import React, { useContext, useEffect, useState } from 'react';
import { SessionContext } from '../contexts/SessionContext';
import { APIContext } from '../contexts/APIContext';
import { PAGE_VIEW } from '../types';
import { useMsal } from '@azure/msal-react';
import {
  getUserIdFromLocalStorage,
  fetchUserDetails,
  trackUserClicks,
  getInitialsFromUName,
  openLinkNewTab,
  fetchSurveyMaster,
  getUserEnterpriseId,
  getValidToken,
} from '../utils';
import { ViewMore } from './ViewMore';
import { Tooltip, TooltipProvider, TooltipTrigger } from './ui/Tooltip';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { TooltipContent } from '@radix-ui/react-tooltip';
import AxiosInstance from '../axiosInstance';

export const LandingPage = (props: any) => {
  const { setPageView, setSelectedSuggestion, setIsPromptRetried } = useContext(SessionContext);
  const {
    chatSessionId,
    websocketConnected,
    userDetails,
    clientData,
    setClientData,
    surveyMaster,
    websocketConnectionRef: { current: websocket },
    WBUId,
    AppName,
    accounts,
    batchType,
  } = useContext(APIContext);
  const { setAccountDetails, deviceType } = useContext(SessionContext);
  // const { accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;
  const foresightLink = 'https://core.foresightai.accenture.com/';

  const newChatPageHandler = async (e?: any, suggestedPrompt?: string) => {
    // eslint-disable-next-line no-extra-boolean-cast
    const token = await getValidToken();
    setIsPromptRetried(false);
    setSelectedSuggestion(suggestedPrompt ?? ''); //set selectedPrompt if passed, to trigger the prompt to backend
    trackUserClicks(websocket, 'GMA Chat LandingPage', userDetails, chatSessionId, WBUId, AppName, accounts, token);
    setPageView(PAGE_VIEW.CHAT);
  };

  useEffect(() => {
    const initials = isAuthenticated ? getInitialsFromUName(accounts[0].name ?? '') : '';
    setAccountDetails((state: any) => ({
      ...state,
      initials,
    }));
  }, [isAuthenticated]);

  useEffect(() => {
    if (websocketConnected && chatSessionId.length == 0) {
      (async () => {
        const token = await getValidToken();
        const request = {
          function: 'generate_sessionuid',
          userId: getUserIdFromLocalStorage(),
          EnterpriseId: getUserEnterpriseId(accounts),
          authorization: `Bearer ${token}`,
        };
        console.log('reqObj for session', request);
        websocket?.send('SendMessage', request);
        fetchUserDetails(accounts, websocket, token);
      })();
    }
  }, [websocketConnected]);

  // useEffect(() => {
  //   if (websocketConnected) {
  //     fetchSurveyMaster(accounts, websocket);
  //   }
  // }, [websocketConnected]);

  useEffect(() => {
    if (websocketConnected && userDetails && userDetails?.GenARCAppUId && userDetails?.GenARCAppUserUId?.length > 0) {
      (async () => {
        const token = await getValidToken();
        trackUserClicks(
          websocket,
          'GMA Landing Page',
          userDetails,
          chatSessionId,
          WBUId,
          AppName,
          accounts,
          token,
          undefined,
          undefined,
          undefined,
          deviceType,
          deviceType
        );
      })();
    }
  }, [websocketConnected, userDetails]);

  useEffect(() => {
    const fetchClientList = async () => {
      if (surveyMaster) {
        try {
          const fetchurl = `${process.env.REACT_APP_CLIENT_URL}`;
          const response = await AxiosInstance.get(fetchurl);
          setClientData(response.data);
        } catch (error) {
          console.error('Error fetching client list:', error);
        }
      }
    };

    fetchClientList();
  }, [surveyMaster]);

  useEffect(() => {
    if (clientData.length > 0) {
      console.log('Client list response:', clientData);
    }
  }, [clientData]);

  return (
    <div className="landing-page-container flex flex-col w-full h-full">
      {/* Top half with background image */}
      <div className="landing-page bg-landing-bg-new-img bg-cover tablet:bg-cover">
        <div className="landing-page-top bg-cover flex w-full flex-col flex-nowrap justify-between gap-8 tablet:gap-20 pb-7 mb-[96px]">
          <div className="landing-page-top-upper-wrapper flex flex-col tablet:gap-6 pl-3 tablet:pl-[46.76px] pt-[52px]">
            <div className="flex">
              <div className="flex flex-col justify-start gap-4 w-4/5">
                <div className="flex flex-col gap-4">
                  <h1 className="title text-lg tablet:text-5xl w-fit font-bold text-white text-opacity-[0.87] leading-[normal] text-left">
                    Introducing
                    <br />
                    Generative Market Analysis
                  </h1>
                  <p className="subtitle text-left w-fit text-sm leading-[140%] font-medium text-white text-opacity-[0.87]">
                    Screen growth pathways to build and develop that are grounded with trusted data.
                  </p>
                </div>
                <button
                  type="button"
                  className="chat-link-btn w-fit bg-white p-2 text-xs tablet:p-4 rounde tablet:text-base leading-[normal] tracking-[0.32px] shadow-[0_4px_10px_0_rgba(0,0,0,0.1) hover:bg-[#F2F2F2] active:bg-[#F2F2F2] disabled:bg-[#B3B2B5]
                "
                  onClick={newChatPageHandler}
                >
                  Experience Generative Market Analysis
                </button>
              </div>
            </div>
          </div>

          <div className="landing-page-top-lower-wrapper flex flex-col flex-nowrap gap-4 tablet:gap-8 tablet:h-[426px] ">
            <p className="lower-title text-sm text-left tablet:text-2xl w-fit text-white text-opacity-[0.87] leading-[140%] place-self-center tablet:font-semibold justify-start tablet:text-start pl-2 tablet:pl-7">
              Kick off the conversation with starter questions like these
            </p>
            {/* Carousel */}
            <div className="carousel-container flex flex-col flex-nowrap w-full gradient-background gap-4">
              <div className="h-fit w-full  justify-center">
                <div className="carousel-items-container flex flex-col flex-nowrap py-[20px] w-full tablet:h-[389px]">
                  {/* Carousel item */}
                  {userDetails?.ConfigurationDetails?.PredefinedPrompts?.map((item: any, index: number) => {
                    return (
                      <>
                        <button className="mb-4 carousel-btn tablet:h-[276px] tablet:mb-0 cursor-default" key={index}>
                          <div className="flex justify-center w-full">
                            <div
                              className={`carousel-item flex w-[90%] tablet:w-[60%] cursor-pointer ${
                                batchType == 'batch' && 'not-clickable'
                              }`}
                              onClick={(e) => newChatPageHandler(e, item.PromptName)} //item.PromptName = suggestedPrompt(s).
                            >
                              <div className="w-[91%] text-left text-neutral-300 text-sm tablet:text-base font-normal leading-[150%] tracking-[-0.28px]">
                                <p>{item.PromptName}</p>
                              </div>
                              <div className="w-[15%] flex justify-end items-center">
                                <img className="" src="/icons/rocket.svg" alt="rocket"></img>
                              </div>
                            </div>
                          </div>
                        </button>
                        <div className="hidden tablet:flex justify-center items-center">
                          {index !== userDetails.ConfigurationDetails.PredefinedPrompts.length - 1 && (
                            <hr className="border-t-0.5 border-[#807D7D] justify-center items-center w-[70%]" />
                          )}
                        </div>
                      </>
                    );
                  })}
                  {userDetails?.ConfigurationDetails?.PredefinedPrompts === undefined && (
                    <div className="flex flex-col justify-center items-center gap-4 h-full w-full">
                      <img src="/icons/loader-ring.svg" className="loader h-38 w-38 mix-blend-screen" />
                      <span className="text-2xl text-white">Loading</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Middle part with foresight button */}
        {/* <div className="flex flex-col tablet:flex-row items-start tablet:items-center justify-between gap-4 tablet:gap-[170px] bg-[linear-gradient(270deg,rgba(63,63,70,0.10)_-4.44%,#640078_32.45%,#280846_69.34%,rgba(63,63,70,0.00)_106.24%)] px-2 py-3 tablet:pt-[25px] tablet:pb-7 tablet:pl-24 tablet:pr-40 border-y-[#807D7D] border-t border-solid border-b tablet:mt-[86px] mb-[46px] tablet:mb-[92px]">
          <div className="text-[#EEE] tablet:text-xl tablet:flex-1 text-left tablet:leading-6 text-sm">
            Search, discover voice of market knowledge along with uploading and ingesting data into our proprietry CORE
            database
          </div>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <button
                  onClick={() => {
                    openLinkNewTab(foresightLink);
                    (async () => {
                      const token = await getValidToken();
                      trackUserClicks(
                        websocket,
                        'Core Foresight',
                        userDetails,
                        chatSessionId,
                        WBUId,
                        AppName,
                        accounts,
                        token
                      );
                    })();
                  }}
                  className="text-gamma-grey text-xs tablet:text-base border border-gamma-grey px-3 py-1.5 tablet:px-5 tablet:py-4 leading-4"
                >
                  Experience Core
                </button>
              </TooltipTrigger>
              <TooltipContent
                side="bottom"
                className="bg-gamma-grey border-0 max-w-[258px] drop-shadow-[0_12px_16px_rgba(0,0,0,0.12)] p-2"
                sideOffset={5}
              >
                <p className="tooltip-content text-black text-xs text-left capitalize not-italic">
                  Discover Market Insights, Upload Data To CORE, And Reveal The Market&apos;s Voice.
                </p>
                <TooltipPrimitive.Arrow width={11} height={5} style={{ fill: '#FAFAFA' }} />
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        </div> */}
        {/* Bottom half with gray background */}
        <div className="flex flex-row justify-center">
          <div className="landing-page-bottom w-full flex flex-col gap-8 tablet:pb-16 tablet:px-12 browser:max-w-[1280px]">
            <div className="landing-page-bottom-upper-wrapper px-4 browser:px-0 flex flex-col justify-start gap-2">
              <h2 className="title text-lg tablet:text-2xl w-fit font-semibold text-white text-opacity-[0.87] leading-[normal] text-center">
                Increase Your Knowledge
              </h2>
              <p className="subtitle w-fit text-xs tablet:text-sm leading-[140%] font-normal text-white text-opacity-[0.87] text-left tablet:text-center">
                Learning and education materials through videos, client stories, and more.
              </p>
            </div>
            <div className="landing-page-bottom-lower-wrapper flex flex-col px-4 browser:px-0 gap-[44px] justify-center items-center browser:items-start browser:flex-row">
              <div className="video-container rounded-[10px] flex-nowrap gap-2 bg-contain tablet:bg-cover">
                <img
                  className="tablet:max-w-fit"
                  src="/branding/newgrowthaitoolbox.svg"
                  alt="Growth.AI Dumbell Graphic"
                />
              </div>
              <div className="more-videos-container h-[532px] max-w-[600px] rounded-[10px] gradient-background">
                <h3 className="title  text-lg w-fit font-semibold text-white leading-[normal] pt-[20px] pl-[20px]">
                  View more
                </h3>
                <div className="view-more h-[422px] p-[20px] ">
                  <ViewMore
                    img={'/branding/analysis.svg'}
                    title={'Demo of Generative Market Analysis'}
                    description={'See it in action through a specific client use case.'}
                    link={
                      'https://ts.accenture.com/sites/GAMMA-GenAIMarketAnalysis/_layouts/15/stream.aspx?id=%2Fsites%2FGAMMA%2DGenAIMarketAnalysis%2FShared%20Documents%2FGeneral%2FVideo%20Production%2FGMC%20Video%2FGenerative%20Market%20Analysis%5FGMC%2Emp4&ga=1&referrer=StreamWebApp%2EWeb&referrerScenario=AddressBarCopied%2Eview'
                    }
                  />
                  <ViewMore
                    img={'/branding/searchAI.svg'}
                    title={'Generative Market Analysis User Guide'}
                    description={
                      "Take a look at our GMA User Guide! Here you'll find the info about the purpose and benefits, navigation tips, and data sources so you know how to make the best use out of GMA."
                    }
                    link={
                      'https://ts.accenture.com/:p:/s/growth.ai310/ER20i3KaWGhLtl_4tOvB1PcBJVVrQOO5g0fNN7LQwBh1PA?e=kdsWjd'
                    }
                  />
                  <ViewMore
                    img={'/branding/thinking.svg'}
                    title={'What Makes a Good Prompt?'}
                    description={
                      'Discover how to accelerate your ability to received quality outputs by learning how to write strong prompts.'
                    }
                    link={'https://kxdocuments.accenture.com/contribution/1a8692c3-ff5b-4640-bd9c-e41b7fe5bb63'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
